import {Avatar, AvatarGroup, Box, Grid} from '@mui/material';
import {Getah, Padi, PalmOil} from '../../../assets';
import {
  PolyphiaATD,
  DataContainerTab,
  RightDropdown,
  UntungRugi,
  DataHasil,
  LaporanKerjaLadang,
  PolyphiaDataHasil,
} from '../..';
import {useCallback, useEffect, useState} from 'react';

export default function Polyphia({
  mapRef,
  mapData,
  rightData,
  tempWeather,
  handleTabSwitch,
  groupName,
  adminFlag,
  adminIotFlag,
  adminLintramaxFlag,
  viewerDigitalMapFlag,
  viewerLintramaxFlag,
  viewerIotFlag,
  wilayahCode,
  newWilayahCode,
  negeriCode,
  pkCode,
  projectCode,
  zoomer,
}) {
  const [menu, setMenu] = useState({
    label: 'Dirian Pokok',
    value: 0,
  });
  const handleRenderMenu = useCallback(
    (menu) => {
      switch (menu) {
        case 0:
        case 1:
        case 2:
          return (
            <DataContainerTab
              mapRef={mapRef}
              menu={menu}
              adminDigitalMapFlag={adminFlag}
              adminIotFlag={adminIotFlag}
              adminLintramaxFlag={adminLintramaxFlag}
              viewerDigitalMapFlag={viewerDigitalMapFlag}
              viewerLintramaxFlag={viewerLintramaxFlag}
              viewerIotFlag={viewerIotFlag}
              data={mapData?.data}
              onData={handleTabSwitch}
              rightData={rightData}
              selectedGroupName={groupName}
              kawasan={rightData.detail.kodKawasa}
              status={'publish'}
            />
          );
        case 3:
          return (
            // <PolyphiaDataHasil
            //   mapRef={mapRef}
            //   wilayahCode={wilayahCode}
            //   negeriCode={negeriCode}
            //   pkCode={pkCode}
            //   projectCode={projectCode}
            // />
            <DataHasil
              mapRef={mapRef}
              wilayahCode={newWilayahCode}
              negeriCode={negeriCode}
              pkCode={pkCode}
              projectCode={projectCode}
              zoomer={zoomer}
            />
          );
        case 4:
          return <LaporanKerjaLadang projectCode={projectCode} />;
        case 5:
          return (
            <PolyphiaATD
              mapRef={mapRef}
              wilayahCode={wilayahCode}
              negeriCode={negeriCode}
              pkCode={pkCode}
              projectCode={projectCode}
            />
          );
        case 6:
          return (
            <UntungRugi
              zoomer={mapRef.current?.getZoom()}
              negeriCode={negeriCode}
              pkCode={pkCode}
              projectCode={projectCode}
              wilayahCode={newWilayahCode}
              mapRef={mapRef}
            />
          );
        default:
          return;
      }
    },
    [
      menu,
      mapData,
      rightData,
      tempWeather,
      handleTabSwitch,
      groupName,
      adminFlag,
      adminIotFlag,
      adminLintramaxFlag,
      viewerDigitalMapFlag,
      viewerLintramaxFlag,
      viewerIotFlag,
    ]
  );
  const handleBackground = (menu) => {
    switch (menu) {
      case 6:
      case 4:
      case 3:
        return '#fff';
      default:
        return '';
    }
  };
  useEffect(() => {
    if (menu.value === 0 || menu.value === 1 || menu.value === 2)
      handleTabSwitch(menu.value);
  }, [menu]);
  return (
    <div
      style={{
        height: '100%',
        overflowY: 'scroll',
        background: 'rgba(255, 255, 255, 0.6)',
        backdropFilter: 'blur(10px)',
        boxShadow: '0 4px 30px rgba(0, 0, 0, 0.1)',
      }}
    >
      <Grid
        container
        sx={{
          padding: 2,
          backgroundColor: '#ceb889',
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <Grid item xs={10}>
          <Box style={{display: 'flex', alignItems: 'center', gap: 5}}>
            <AvatarGroup max={3}>
              {mapData?.data?.janis_tanaman?.sawit === true && (
                <Avatar alt='Travis Howard' src={PalmOil} />
              )}
              {mapData?.data?.janis_tanaman?.getah === true && (
                <Avatar alt='Travis Howard' src={Getah} />
              )}
              {mapData?.data?.janis_tanaman?.padi === true && (
                <Avatar alt='Travis Howard' src={Padi} />
              )}
            </AvatarGroup>
            <div>
              <div style={{fontWeight: 'bold'}}>
                {rightData?.detail?.namaProjek}
              </div>
              <div style={{fontSize: '12px'}}>
                {rightData?.detail?.kodProjek}
                <span> | </span>
                {rightData?.detail?.namaKawasa}
              </div>
            </div>
          </Box>
        </Grid>

        <Grid item xs={2}>
          <Avatar alt='Travis Howard' src={tempWeather?.link} />
        </Grid>
      </Grid>
      <div
        style={{
          width: '100%',
          padding: '10px',
          background: handleBackground(menu.value),
        }}
      >
        <RightDropdown
          menu_list={[
            {label: 'Dirian Pokok', value: 0},
            {label: 'Jalan', value: 1},
            {label: 'Guna Tanah', value: 2},
            {label: 'Data Hasil', value: 3},
            {label: 'Laporan Kerja Ladang', value: 4},
            {label: 'Analisis Tanah dan Daun (ATD)', value: 5},
            {label: 'Untung dan Rugi', value: 6},
          ]}
          selectedMenu={menu}
          onClick={(item) => {
            setMenu(item);
          }}
        />
      </div>
      {handleRenderMenu(menu.value)}
    </div>
  );
}
